const FORA_LOGO_URL = "https://customer-assets.emergentagent.com/job_venue-dining-1/artifacts/ahuwpdsq_image.png";
const ARENA_LOGO_URL = "https://customer-assets.emergentagent.com/job_venue-dining-1/artifacts/je84hl8j_image.png";

export const ForaLogo = ({ height = "h-7", clickable = true }) => {
  if (clickable) {
    return (
      <a
        data-testid="fora-logo"
        href="https://fora.solutions"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center shrink-0"
      >
        <img src={FORA_LOGO_URL} alt="FORA" className={`${height} w-auto object-contain`} />
      </a>
    );
  }
  return (
    <span data-testid="fora-logo" className="inline-flex items-center shrink-0">
      <img src={FORA_LOGO_URL} alt="FORA" className={`${height} w-auto object-contain`} />
    </span>
  );
};

export const ArenaCateringLogo = ({ height = "h-7", clickable = true }) => {
  if (clickable) {
    return (
      <a
        data-testid="arena-catering-logo"
        href="https://arenacatering.pl"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center shrink-0"
      >
        <img src={ARENA_LOGO_URL} alt="Arena Catering" className={`${height} w-auto object-contain`} />
      </a>
    );
  }
  return (
    <span data-testid="arena-catering-logo" className="inline-flex items-center shrink-0">
      <img src={ARENA_LOGO_URL} alt="Arena Catering" className={`${height} w-auto object-contain`} />
    </span>
  );
};
